import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';
import { assertAllowedProps } from '../../utils/events';

const cx = classNames.bind(styles);

export default function LinkBlock(props) {
  const { children, href, title, target, onClick, className, ...eventHandlers } = props;
  assertAllowedProps(eventHandlers);

  const Tag = href ? 'a' : 'div';

  return (
    <Tag
      className={cx(className, { link: href || onClick })}
      data-component="Link"
      target={href ? target : null}
      {...{ href, onClick, title }}
      {...eventHandlers}
    >
      {children}
    </Tag>
  );
}

LinkBlock.defaultProps = {
  children: null,
  target: '_self',
};

LinkBlock.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  onClick: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};
